import Vue from 'vue'
import Router from 'vue-router'
import GodBossHome from '../views/Home.vue'
import Promotion from '../views/Promotion.vue'
import PGPromo from '../views/PGPromo.vue'
Vue.use(Router)

export default new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      name: 'option',
      redirect: () => {
          return '/home';
      },
    },
    {
      path: '/home',
      name: 'Home',
      component: GodBossHome
    },
    {
      path: '/promotion',
      name: 'Promotion',
      component: Promotion
    },  
    {
      path: '/pgpromo',
      name: 'PGPromo',
      component: PGPromo  ,
    }
  ]
})

